module.exports = __webpack_public_path__ + "pw.svg?4e697b0478400bead77a4c79b1b96d8a";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/pw.svg
// module id = 1167
// module chunks = 27